import { FunctionComponent, useState } from 'react'
import { IconButton } from '@black-bear-energy/rucksack'
import { ChatBubbleOutlineRounded } from '@mui/icons-material'
import { CommentModal } from './CommentModal'
import { ChecklistDocument } from '@black-bear-energy/black-bear-energy-common'

export const ReviewComment: FunctionComponent<ReviewCommentProps> = ({
  document,
}) => {
  const [commentModalOpen, setCommentModalOpen] = useState(false)
  return (
    <>
      {document.review?.comment && (
        <>
          <IconButton onClick={() => setCommentModalOpen(true)}>
            <ChatBubbleOutlineRounded />
          </IconButton>
          <CommentModal
            documentName={document.name}
            review={document.review}
            pendingReview={document.review.outdated}
            open={commentModalOpen}
            handleClose={() => setCommentModalOpen(false)}
          />
        </>
      )}
    </>
  )
}

interface ReviewCommentProps {
  document: ChecklistDocument
}
